import * as Redux from "redux";
import storage from "redux-persist/lib/storage";

import { UserActions } from "src/core/users/store/users.actions";
import * as AT from "src/core/users/store/users.constants";
import { IUser } from "src/core/users/api/users.api";

export interface IUsersStore {
  user: IUser | null;
}

const initialState: IUsersStore = { user: null };

export const usersReducer: Redux.Reducer<IUsersStore> = (state: IUsersStore = initialState, action: UserActions): IUsersStore => {
  switch (action.type) {
    case AT.SET_USER:
      return {
        ...state,
        user: action.user
      };

    case AT.PURGE_USERS:
      return initialState;
    default:
      return state;
  }
};

// config for persisting within this reducer
export const usersPersistConfig = {
  key: "users",
  storage,
  blacklist: [ "" ]
};
